export default "/images/chart1.jpg?d24f05c5de7aa7dc82cf0671f1eceab3";